module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#fcfcfd"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.gotoHome()
      }
    }
  }, [_vm._v("HOME")]), _vm._v(" - SERVICE")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "30px 0px",
      "padding-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('left')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "color": "#333",
      "font-size": "15px",
      "line-height": "25px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.$t('service_title_1')) + "            ")]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.$t('service_title_2')) + "       \n            ")]), _vm._v(" "), _c('div', [_c('li', [_vm._v(_vm._s(_vm.$t('service_q_1')) + "       ")])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('service_a_1')) + "  ")]), _vm._v(" "), _c('div', [_c('li', [_vm._v(_vm._s(_vm.$t('service_q_2')) + "       ")])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('service_a_2')) + "  ")]), _vm._v(" "), _c('div', [_c('li', [_vm._v(_vm._s(_vm.$t('service_q_3')) + "       ")])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('service_a_3')) + "  ")]), _vm._v(" "), _c('div', [_c('li', [_vm._v(_vm._s(_vm.$t('service_q_4')) + "       ")])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('service_a_4')) + "  ")]), _vm._v(" "), _c('div', [_c('li', [_vm._v(_vm._s(_vm.$t('service_q_5')) + "       ")])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('service_a_5')) + "  ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "30px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "box-shadow": "0px 0px 10px #aaa"
    },
    attrs: {
      "src": "/static/images/service.jpeg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ec05e99"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/service.vue
// module id = 1398
// module chunks = 1